import { useOrderApprovalHistory } from '@hooks';
import { observer } from 'mobx-react';
import React from 'react';
import Presentation from './OrderApprovalHistory.presentation';

interface IProps {
  orderId?: string;
  customerId?: string;
  registrationNumber?: string;
  customerEmail?: string;
  customerUserId?: number;
  customerFullName?: string;
  orderStatus?: string;
}

export const OrderApprovalHistory: React.FC<IProps> = observer(
  ({ orderId, customerId, registrationNumber, customerEmail, customerUserId, customerFullName, orderStatus }) => {
    const approvalHistoryHook = useOrderApprovalHistory({
      orderId,
      customerId,
      registrationNumber,
    });

    return (
      <Presentation
        approvalHistoryHook={approvalHistoryHook}
        customerEmail={customerEmail}
        customerId={customerId}
        customerUserId={customerUserId}
        customerFullName={customerFullName}
        orderStatus={orderStatus}
        orderId={orderId}
        registrationNumber={registrationNumber}
      />
    );
  }
);
